var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "switch-vertical-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 4V20M7.5 20L3.5 16M7.5 20L11.5 16M17.5 20V4M17.5 4L13.5 8M17.5 4L21.5 8",
    stroke: "#2ED3B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchVertical);
export default __webpack_public_path__ + "static/media/switch-vertical.37a94e1ea59befb963d3a7a50faaf427.svg";
export { ForwardRef as ReactComponent };